import { render, staticRenderFns } from "./daisy-message.view.vue?vue&type=template&id=548f4166&scoped=true&"
import script from "./daisy-message.view.vue?vue&type=script&lang=ts&"
export * from "./daisy-message.view.vue?vue&type=script&lang=ts&"
import style0 from "./daisy-message.view.vue?vue&type=style&index=0&id=548f4166&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548f4166",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VContainer,VDivider})
